import React from "react";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import { Button, ProcessingButton } from "@qgiv/core-donor";
import ConnectedStoreBackButton from "./ConnectedStoreBackButton";

const Submit = ({
    advanceForwardButtonLabel = "Skip",
    controlId,
    isCms = false,
}) => {
    const { isSubmitting } = useFormikContext();

    return (
        // eslint-disable-next-line tailwindcss/classnames-order
        <div className="grid grid--align-items-center -margin-top--30">
            <div className="col col--12 col--xl-6 col--order-2 col--xl-order-1">
                <ConnectedStoreBackButton controlId={controlId} />
            </div>
            <div className="col col--12 col--xl-6 col--order-1 col--xl-order-2">
                {isSubmitting ? (
                    <ProcessingButton />
                ) : (
                    <Button
                        type="submit"
                        name="Save_And_Continue"
                        onClick={(e) => {
                            // we do not want to submit anything in cms view
                            if (isCms) {
                                e.preventDefault();
                                // eslint-disable-next-line no-useless-return
                                return;
                            }
                        }}
                    >
                        {advanceForwardButtonLabel}
                    </Button>
                )}
            </div>
        </div>
    );
};

Submit.propTypes = {
    advanceForwardButtonLabel: PropTypes.string.isRequired,
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    isCms: PropTypes.bool.isRequired,
};

export default Submit;
